<div class="support-page">

  <!-- ─── HEADER ─── -->
  <div class="support-header">
    <div class="support-heading">
      <div class="support-heading-icon">
        <i class="fas fa-headset"></i>
      </div>
      <div>
        <h1 class="support-title">{{ 'SUPPORT.TITLE' | translate }}</h1>
        <p class="support-subtitle">{{ 'SUPPORT.SUBTITLE' | translate }}</p>
      </div>
    </div>
  </div>

  <!-- ─── EMAIL FEATURED ─── -->
  <div class="support-featured">
    <div class="support-featured-icon">
      <i class="fas fa-envelope"></i>
    </div>
    <div class="support-featured-body">
      <span class="support-featured-tag">Canale principale</span>
      <div class="support-featured-title">{{ 'SUPPORT.CARDS.EMAIL.TITLE' | translate }}</div>
      <div class="support-featured-desc">{{ 'SUPPORT.CARDS.EMAIL.DESCRIPTION' | translate }}</div>
    </div>
    <a href="mailto:supporto.ricambi@bertanitrasporti.it" class="support-featured-btn">
      <i class="fas fa-envelope"></i>
      Invia email
    </a>
  </div>

  <!-- ─── SECONDARY CARDS ─── -->
  <div class="support-grid">

    <div class="contact-card">
      <div class="contact-card-icon contact-icon--phone">
        <i class="fas fa-phone"></i>
      </div>
      <div class="contact-card-body">
        <span class="contact-label">{{ 'SUPPORT.CARDS.PHONE.TITLE' | translate }}</span>
        <span class="contact-value">{{ 'SUPPORT.CARDS.PHONE.DESCRIPTION' | translate }}</span>
      </div>
    </div>

    <div class="contact-card">
      <div class="contact-card-icon contact-icon--address">
        <i class="fas fa-map-marker-alt"></i>
      </div>
      <div class="contact-card-body">
        <span class="contact-label">{{ 'SUPPORT.CARDS.ADDRESS.TITLE' | translate }}</span>
        <span class="contact-value">{{ 'SUPPORT.CARDS.ADDRESS.DESCRIPTION' | translate }}</span>
      </div>
    </div>

    <div class="contact-card">
      <div class="contact-card-icon contact-icon--hours">
        <i class="fas fa-clock"></i>
      </div>
      <div class="contact-card-body">
        <span class="contact-label">{{ 'SUPPORT.CARDS.WORKING_HOURS.TITLE' | translate }}</span>
        <span class="contact-value">{{ 'SUPPORT.CARDS.WORKING_HOURS.DESCRIPTION' | translate }}</span>
      </div>
    </div>

  </div>

</div>
